module.exports = __webpack_public_path__ + "img/skills-illustration.da4f5cdf.svg";